import {
    INVESTIGATION_DRAWER_ENTITY_TYPES,
    INVESTIGATION_ENTITY_TYPES
} from '@silverfort-nodelibs/common/utils/consts';
import ReactMarkdown from 'react-markdown';
import IncidentDetails from './IncidentDetails';

import React, { useState } from 'react';
import InvestigationSection from './InvestigationSection';
import { Loader } from '../../../components/Loader/Loader';
import EntityActivities from '../../../components/Investigation/InvestigationComponents/EntityActivities/EntityActivities';
import EntityData from '../../../components/Investigation/InvestigationComponents/EntityData/EntityData';

const ENTITIES_FIELDS = {
    users: {
        title: 'Users',
        entityType: { ...INVESTIGATION_ENTITY_TYPES.USER, adType: INVESTIGATION_DRAWER_ENTITY_TYPES.USER.adType }
    },
    servers: {
        title: 'Destinations',
        entityType: {
            ...INVESTIGATION_ENTITY_TYPES.RESOURCE,
            adType: INVESTIGATION_DRAWER_ENTITY_TYPES.RESOURCE.adType
        }
    },
    hosts: {
        title: 'Devices',
        entityType: { ...INVESTIGATION_ENTITY_TYPES.DEVICE, adType: INVESTIGATION_DRAWER_ENTITY_TYPES.DEVICE.adType }
    }
};

const ENTITIES_FIELDS_OPTIONS = Object.entries(ENTITIES_FIELDS).map(([key, field]) => ({
    title: field.title,
    value: key
}));

const IncidentOverview = ({
    incidentID,
    incidentData,
    userData,
    showLoader,
    onStatusChange,
    incidentType,
    incidentSummary
}) => {
    const [selectedEntitiesField, setSelectedEntitiesField] = useState(ENTITIES_FIELDS_OPTIONS[0].value);
    return (
        <div className="grid grid-rows-[minmax(20%,200px)_minmax(min-content,_80%)] grid-cols-[60%_40%] gap-4 h-[calc(100%_-_60px)] w-[calc(100%_-_16px)] px-8 py-5">
            <InvestigationSection sectionClass="w-full h-full" title="Incident Details">
                <Loader isLoading={showLoader || !incidentData} className="h-10 w-10">
                    <IncidentDetails
                        incidentData={incidentData}
                        userData={userData}
                        incidentTypeObj={incidentType}
                        onStatusChange={onStatusChange}
                    />
                </Loader>
            </InvestigationSection>
            <InvestigationSection sectionClass="w-full h-full" title="Incident Summary">
                <div className="whitespace-normal truncate text-14 font-sf text-sf-gray-100">
                    <ReactMarkdown className="whitespace-normal truncate text-14 font-sf text-sf-gray-100">
                        {incidentSummary ?? 'No summary yet'}
                    </ReactMarkdown>
                </div>
            </InvestigationSection>
            <InvestigationSection title="Incident Timeline">
                {!showLoader && incidentData && (
                    <EntityActivities
                        entityId={incidentID}
                        entityType={INVESTIGATION_ENTITY_TYPES.INCIDENT}
                        user={userData}
                        hideRightMargin={true}
                        mainEntityGuid={incidentData.mainEntities?.[0]?.guid}
                        entityGuid={undefined}
                    />
                )}
            </InvestigationSection>
            <InvestigationSection title="Attacked Entities">
                <div className="flex flex-col gap-4">
                    <div className="h-4 flex flex-1 items-center justify-between bg-sf-dark-400 rounded cursor-pointer">
                        {ENTITIES_FIELDS_OPTIONS.map((option) => (
                            <div
                                key={option.value}
                                className={`px-4 py-2 h-full w-full rounded flex items-center justify-center text-13 font-sf hover:bg-sf-dark-500 ${
                                    selectedEntitiesField === option.value
                                        ? 'border border-sf-primary-500 bg-sf-dark-500 text-sf-white'
                                        : 'text-sf-light-500'
                                }`}
                                onClick={() => setSelectedEntitiesField(option.value)}>
                                {option.title}
                            </div>
                        ))}
                    </div>
                    <div className="flex w-full h-full min-h-20 flex-grow flex-shrink">
                        {incidentData?.[selectedEntitiesField]?.length ? (
                            <EntityData
                                isMultiple={true}
                                entitiesData={incidentData?.[selectedEntitiesField] ?? []}
                                entityType={ENTITIES_FIELDS[selectedEntitiesField].entityType}
                                user={userData}
                                minimizedView
                                showGoToInvestigation
                                entityGuid={undefined}
                                displayName={undefined}
                                setEntityId={undefined}
                            />
                        ) : (
                            <div className="w-full flex items-center justify-center text-sf-gray-100 text-14">
                                No involved entities of this type
                            </div>
                        )}
                    </div>
                </div>
            </InvestigationSection>
        </div>
    );
};

export default IncidentOverview;
